<template>
  <div>
    <LoadingDialog
      ref="LoadingDialog"
      message="Applying template..."
      :specific="true"
    />
    <v-dialog v-model="dialog" max-width="1800px">

      <template v-slot:activator="{ on }">
        <span v-if="!selectedEnrollment">
          <v-btn
            block class="mx-5 block-button button-style-blue"
            v-on="on"
            @click="getPreviousYearBalance(previousSchoolYear)"
            >Enroll to this School Year
          </v-btn>
        </span>
        <span v-else></span>
      </template>
      <v-form
        v-model="valid"
        ref="form"
        lazy-validation
      >
        <v-card>
          <v-card-title>
            <span class="headline"> Enrollment Form - {{ student.full_name }} ({{ schoolYear.name }}) </span>
          </v-card-title>
            <v-container grid-list-md class="fluid-full">
              <v-layout row wrap>

                <v-flex xs12 md4>
                  <v-card>
                    <v-toolbar flat color="white" class="pt-2">
                      <span class="title"><strong>Enrollment Details</strong></span>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-card-title class="mx-4">
                          <v-layout row wrap>
                            <v-flex xs12 class="box-white">
                              <v-menu
                                v-model="menu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    v-model="newEnrollment.enrollment_date"
                                    height="32"
                                    label="Enrollment Date *"
                                    readonly
                                    color="#091D3B"
                                    v-on="on"
                                    :rules="[v => !!v || 'Enrollment Date is required']"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="newEnrollment.enrollment_date"
                                  @input="menu = false"
                                >
                                </v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs12>
                              <v-select
                                v-model="newEnrollment.grade_level"
                                item-text="text"
                                :items="gradeLevels"
                                @change="loadTemplate"
                                color="#091D3B"
                                :rules="[v => !!v || 'Grade Level is required']"
                                label="Grade Level *">
                              </v-select>
                            </v-flex>
                            <v-flex xs12>
                              <v-select
                                v-model="newEnrollment.payment_plan"
                                :items="paymentPlan"
                                @change="loadTemplate"
                                color="#091D3B"
                                :rules="[v => !!v || 'Grade Level is required']"
                                label="Payment Plan *">
                              </v-select>
                            </v-flex>
                            <v-flex xs12>
                              <v-select
                                v-model="newEnrollment.enrollment_type"
                                :items="enrollmentType"
                                @change="loadTemplate"
                                color="#091D3B"
                                :rules="[v => !!v || 'Enrollment Type is required']"
                                label="Enrollment Type *">
                              </v-select>
                            </v-flex>
                            <v-flex xs12>
                              <v-select
                                v-model="newEnrollment.track_type"
                                :items="trackType"
                                @change="loadTemplate"
                                :disabled="(newEnrollment.grade_level < 14 ? true : false)"
                                color="#091D3B"
                                label="Track Type *">
                              </v-select>
                            </v-flex>
                            <v-flex xs12>
                              <v-textarea
                                v-model="newEnrollment.remarks"
                                color="#091D3B"
                                rows="1"
                                auto-grow
                                label="Remarks"
                              >
                              </v-textarea>
                            </v-flex>
                            <!-- ADD BOOKS SECTION -->
                            <v-flex xs12>
                              <v-card>
                                <v-expansion-panel expand v-model="bookPanel">
                                  <v-expansion-panel-content>
                                    <template v-slot:header>
                                      <div>Books ({{newEnrollment.books.length}})</div>
                                    </template>
                                      <v-card-text v-if="newEnrollment.books.length >= 1">
                                        <v-layout v-for="(book, index) in newEnrollment.books">
                                          <v-flex xs6>
                                            <v-text-field :rules="[v => !!v || 'Subject is required']" color="#091D3B" label="Subject" v-model="book.subject"> </v-text-field>
                                          </v-flex>
                                          <v-flex xs12 md4>
                                            <v-currency-field
                                              :rules="
                                                [
                                                  v => !!v || 'Price is required',
                                                  v => parseFloat(v) > 0 || 'Price cannot be less than or equal to 0',
                                                ]"
                                              prefix="₱"
                                              color="#091D3B"
                                              label="Price"
                                              :type="'number'"
                                              v-model="book.price"> </v-currency-field>
                                          </v-flex>
                                          <v-flex xs2>
                                            <v-btn style="padding: 0 10px;" color="#B71C1C" dark class="small-button" @click="deleteBook(index)"><v-icon small>close</v-icon></v-btn>
                                          </v-flex>
                                        </v-layout>
                                      </v-card-text>
                                      <v-card-text primary-title>
                                          <v-flex xs12>
                                            <v-btn block class="button-style-blue" @click="addBook">Add Books</v-btn>
                                          </v-flex>
                                      </v-card-text>
                                  </v-expansion-panel-content>
                                </v-expansion-panel>
                              </v-card>
                            </v-flex>
                            <!-- ADD BOOKS SECTION END-->
                          </v-layout>
                        </v-card-title>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 md4>
                  <v-card>
                    <v-toolbar flat color="white" class="pt-2">
                      <span class="title"><strong>Downpayment</strong></span>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-card-title class="mx-4">
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-currency-field
                                v-model="newEnrollment.previous_year_balance"
                                class="template-message"
                                :type="'number'"
                                color="#091D3B"
                                prefix="₱"
                                label="(Previous Year's Balance)"
                                >
                              </v-currency-field>
                              <v-currency-field
                                class="template-message"
                                v-model="newEnrollment.tuition_fee"
                                :type="'number'"
                                color="#091D3B"
                                prefix="₱"
                                label="Tuition Fee"
                                :messages="(newEnrollment.template ? `${getGradeLevelDisplay(newEnrollment.grade_level)} +  ${getPaymentPlanDisplay(newEnrollment.payment_plan)}: ₱${newEnrollment.template.tuition_fee}`: '')"
                                >
                              </v-currency-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-currency-field
                                class="template-message"
                                v-model="newEnrollment.registration_fee"
                                type="number"
                                color="#091D3B"
                                prefix="₱"
                                label="Registration Fee"
                                :messages="(newEnrollment.template ? `${getGradeLevelDisplay(newEnrollment.grade_level)} +  ${getPaymentPlanDisplay(newEnrollment.payment_plan)}: ₱${newEnrollment.template.registration_fee}`: '')"
                                >
                              </v-currency-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-currency-field
                                class="template-message"
                                v-model="newEnrollment.miscellaneous_fee"
                                :type="'number'"
                                color="#091D3B"
                                prefix="₱"
                                label="Miscellaneous Fee"
                                :messages="(newEnrollment.template ? `${getGradeLevelDisplay(newEnrollment.grade_level)} +  ${getPaymentPlanDisplay(newEnrollment.payment_plan)}: ₱${newEnrollment.template.miscellaneous_fee}`: '')"
                                >
                              </v-currency-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-currency-field
                                class="template-message"
                                v-model="newEnrollment.computer_fee"
                                :type="'number'"
                                color="#091D3B"
                                prefix="₱"
                                label="Computer Fee"
                                :messages="(newEnrollment.template ? `${getGradeLevelDisplay(newEnrollment.grade_level)} +  ${getPaymentPlanDisplay(newEnrollment.payment_plan)}: ₱${newEnrollment.template.computer_fee}`: '')"
                                >
                              </v-currency-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-currency-field
                                class="template-message"
                                v-model="totalBooksFee"
                                :type="'number'"
                                color="#091D3B"
                                prefix="₱"
                                label="Books"
                                disabled
                                :messages="(newEnrollment.template ? `${getGradeLevelDisplay(newEnrollment.grade_level)} +  ${getPaymentPlanDisplay(newEnrollment.payment_plan)}: ₱${newEnrollment.template.total_books_fee}`: '')"
                                >
                              </v-currency-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-currency-field
                                class="template-message"
                                v-model="newEnrollment.esc_subsidy"
                                :type="'number'"
                                color="#091D3B"
                                prefix="₱"
                                label="ESC Subsidy"
                                :messages="(newEnrollment.template ? `${getGradeLevelDisplay(newEnrollment.grade_level)} +  ${getPaymentPlanDisplay(newEnrollment.payment_plan)}: ₱${newEnrollment.template.esc_subsidy}`: '')"
                                >
                              </v-currency-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-currency-field
                                v-model="newEnrollment.discount"
                                :type="'number'"
                                color="#091D3B"
                                prefix="₱"
                                label="Discount">
                              </v-currency-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-currency-field
                                :value="totalDownpayment"
                                :messages="toWords(totalDownpayment)"
                                color="#091D3B"
                                prefix="₱"
                                label="Total Downpayment" disabled>
                              </v-currency-field>
                            </v-flex>

                          </v-layout>
                        </v-card-title>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 md4>
                  <v-card>
                    <v-toolbar flat color="white" class="pt-2">
                      <span class="title"><strong>Installment</strong></span>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-card-title class="mx-4">
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-text-field
                                class="template-message"
                                v-model="newEnrollment.num_installments"
                                type="number"
                                color="#091D3B"
                                label="Number of Installments"
                                :messages="(newEnrollment.template ? `${getGradeLevelDisplay(newEnrollment.grade_level)} +  ${getPaymentPlanDisplay(newEnrollment.payment_plan)}: ${newEnrollment.template.num_installments}`: '')"
                                >
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-currency-field
                                class="template-message"
                                v-model="newEnrollment.installment_amount"
                                :type="'number'"
                                color="#091D3B"
                                prefix="₱"
                                label="Installment Amount"
                                :messages="(newEnrollment.template ? `${getGradeLevelDisplay(newEnrollment.grade_level)} +  ${getPaymentPlanDisplay(newEnrollment.payment_plan)}: ₱${newEnrollment.template.installment_amount}`: '')"
                                >
                              </v-currency-field>
                            </v-flex>
                          </v-layout>
                        </v-card-title>
                      </v-flex>
                    </v-layout>
                  </v-card>
                  <v-card class="button-style-blue mt-4">
                    <v-toolbar flat class="button-style-blue pt-2">
                      <span class="title"><strong>Total</strong></span>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-card-title class="mx-4">
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-currency-field
                                class="disabled-field-underline important mb-2"
                                :value="totalTuition"
                                :messages="toWords(totalTuition)"
                                prefix="₱"
                                label="Total Tuition"
                                disabled>
                              </v-currency-field>
                            </v-flex>
                            <v-flex xs12 v-if="remainingBalance">
                              <v-currency-field
                                class="disabled-field-underline important"
                                :value="remainingBalance"
                                prefix="₱"
                                label="Remaining Balance"
                                disabled>
                              </v-currency-field>
                            </v-flex>
                            <v-flex xs12 v-if="remainingBalance < 0">
                              <span class="red--text">Balance cannot be less than 0</span>
                            </v-flex>
                          </v-layout>
                        </v-card-title>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          <v-divider light></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#091D3B" outline @click="dialog=false">Close</v-btn>
            <v-btn color="red darken-1 white--text" @click="forceApplyTemplate" v-if="newEnrollment.id">Force Apply Template</v-btn>
            <v-btn class="button-style-blue hide-on-mobile" @click="submitEnrollmentForm">Save</v-btn>
          </v-card-actions>
          <v-card-actions class="mobile-only ml-1"><v-btn class="button-style-blue" @click="submitEnrollmentForm">Save</v-btn></v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import numberToWords from 'number-to-words'

import LoadingDialog from '@/components/LoadingDialog.vue'

export default {
  name: 'enrollment',
  components: {
    LoadingDialog
  },
  props: {
    successCallback: Function,
    selectedEnrollment: Object,
    previousSchoolYear: Object,
  },
  computed: {
    ...mapState(['schoolYear', 'student', 'enrollments']),
    installmentBreakdown () {
      if (this.newEnrollment.payment_plan == 1) {
        return (['July', 'August', 'September', 'October', 'November', 'December', 'January', 'February', 'March'])
      } else if (this.newEnrollment.payment_plan == 2) {
        return (['September', 'December', 'March'])
      } else if (this.newEnrollment.payment_plan == 3) {
        return (['November'])
      } else {
        return []
      }
    },
    totalDownpayment () {
      return (
        (this.newEnrollment.previous_year_balance ? parseFloat(this.newEnrollment.previous_year_balance) : 0) +
        (this.newEnrollment.tuition_fee ? parseFloat(this.newEnrollment.tuition_fee): 0) +
        (this.newEnrollment.registration_fee ? parseFloat(this.newEnrollment.registration_fee) : 0) +
        (this.newEnrollment.miscellaneous_fee ? parseFloat(this.newEnrollment.miscellaneous_fee) : 0) +
        (this.newEnrollment.computer_fee ? parseFloat(this.newEnrollment.computer_fee) : 0) +
        (this.totalBooksFee ? parseFloat(this.totalBooksFee) : 0) -
        (this.newEnrollment.esc_subsidy ? parseFloat(this.newEnrollment.esc_subsidy) : 0) -
        (this.newEnrollment.discount ? parseFloat(this.newEnrollment.discount) : 0)
      ).toFixed(2);
    },
    totalTuition () {
      let totalInstallment = parseFloat(
        (this.newEnrollment.num_installments ? parseFloat(this.newEnrollment.num_installments): 0) *
        (this.newEnrollment.installment_amount ? parseFloat(this.newEnrollment.installment_amount) : 0)
      ).toFixed(2);
      return (parseFloat(this.totalDownpayment) + parseFloat(totalInstallment)).toFixed(2);
    },
    totalBooksFee () {
      if (this.newEnrollment.books) {
        return (this.newEnrollment.books.reduce((accumulator, currentValue) => {
          return accumulator + (currentValue.price ? parseFloat(currentValue.price) : 0)
        }, 0)).toFixed(2)
      } else {
        return 0
      }
    },
    remainingBalance () {
      return (parseFloat(this.newEnrollment.remaining_balance || 0) - (parseFloat(this.newEnrollment.total_tuition || 0) - parseFloat(this.totalTuition))).toFixed(2);
    }
  },
  data () {
    return {
      bookPanel: [true],
      menu: false,
      valid: true,
      dialog: false,
      previousEnrollment: null,
      headerBreakdown: [
        {
          text: 'Month',
          align: 'left',
          sortable: false,
          width: '50%'
        },
        {
          text: 'Amount',
          align: 'left',
          sortable: false,
          width: '50%'
        },
      ],
      paymentPlan: [
        { value: 1, text: 'Monthly (June to March)'},
        { value: 2, text: 'Quarterly (Jun/Sep/Dec/Mar)'},
        { value: 3, text: 'Half Payment (November)'},
        { value: 4, text: 'Full Payment'}
      ],
      enrollmentType: [
        { value: 1, text: 'Old'},
        { value: 2, text: 'Transferee (Public School)'},
        { value: 3, text: 'Transferee (Private School)'},
        { value: 4, text: 'New'}
      ],
      gradeLevels: [
        { value: 1,  text: 'Nursery'},
        { value: 2,  text: 'Kinder 1'},
        { value: 3,  text: 'Kinder 2'},
        { value: 4,  text: 'Grade 1'},
        { value: 5,  text: 'Grade 2'},
        { value: 6,  text: 'Grade 3'},
        { value: 7,  text: 'Grade 4'},
        { value: 8,  text: 'Grade 5'},
        { value: 9,  text: 'Grade 6'},
        { value: 10, text: 'Grade 7'},
        { value: 11, text: 'Grade 8'},
        { value: 12, text: 'Grade 9'},
        { value: 13, text: 'Grade 10'},
        { value: 14, text: 'Grade 11'},
        { value: 15, text: 'Grade 12'}
      ],
      trackType: [
        { value: 1, text: 'N/A'},
        { value: 2, text: 'Academic'},
        { value: 3, text: 'Tech/Voc - Home Economics - Cookery/Baking and Pastry'}
      ],
      newEnrollment: {
        total_tuition: 0,
        grade_level: null,
        section: '',
        school_year: null,
        enrollment_type: null,
        track_type: 1,
        tuition_fee: 0,
        registration_fee: 0,
        miscellaneous_fee: 0,
        computer_fee: 0,
        esc_subsidy: 0,
        num_installments: 0,
        installment_amount: 0,
        template_total_tuition: null,
        discount: 0,
        student_number: null,
        enrollment_date: new Date().toISOString().substr(0, 10),
        payment_plan: null,
        books: [],
        previous_year_balance: 0,
      }
    }
  },
  methods: {
    ...mapActions([
      'createEnrollment',
      'updateEnrollment',
      'getTemplate',
      'getEnrollments',
    ]),
    getPreviousYearBalance (previousSchoolYear) {
      if (previousSchoolYear) {
        this.getEnrollments({school_year: previousSchoolYear.id, student: this.$route.params.id})
        .then(() => {
          if (this.enrollments.length) {
            this.previousEnrollment = this.enrollments[0]
            this.newEnrollment.previous_year_balance = this.previousEnrollment.remaining_balance
          }
        })
      }
    },
    getGradeLevelDisplay (gradeLevelValue) {
      const gradeLevel = this.gradeLevels.find((gradeLevel) => {
        return gradeLevel.value === gradeLevelValue
      })
      return gradeLevel && gradeLevel.text
    },
    getPaymentPlanDisplay (paymentPlanValue) {
      const paymentPlan = this.paymentPlan.find((paymentPlan) => {
        return paymentPlan.value === paymentPlanValue
      })
      return paymentPlan && paymentPlan.text
    },
    addBook () {
      this.newEnrollment.books.push({subject: '', price: 0})
    },
    deleteBook (index) {
      confirm('Are you sure you want to remove') && this.newEnrollment.books.splice(index, 1)
    },
    toWords (total) {
      if (! total) {
        return ''
      }
      return numberToWords.toWords(total);
    },
    applyTemplate () {
      this.$refs.LoadingDialog.dialog = true
      let queryString = `&payment_plan=${this.newEnrollment.payment_plan}&grade_level=${this.newEnrollment.grade_level}`
      if (this.newEnrollment.enrollment_type) {
        queryString += `&enrollment_type=${this.newEnrollment.enrollment_type}`
      }
      if (this.newEnrollment.track_type) {
        queryString += `&track_type=${this.newEnrollment.track_type}`
      }
      this.getTemplate(queryString)
        .then((data) => {
          this.newEnrollment.template_total_tuition = data.total_tuition
          this.newEnrollment.tuition_fee = data.tuition_fee
          this.newEnrollment.registration_fee = data.registration_fee
          this.newEnrollment.miscellaneous_fee = data.miscellaneous_fee
          this.newEnrollment.computer_fee = data.computer_fee
          this.newEnrollment.books = data.books
          this.newEnrollment.num_installments = data.num_installments
          this.newEnrollment.installment_amount = data.installment_amount
          this.newEnrollment.esc_subsidy = data.esc_subsidy
          this.newEnrollment.discount = data.discount
          this.newEnrollment.template = {
            tuition_fee: data.tuition_fee,
            registration_fee: data.registration_fee,
            miscellaneous_fee: data.miscellaneous_fee,
            computer_fee: data.computer_fee,
            total_books_fee: data.total_books_fee,
            num_installments: data.num_installments,
            installment_amount: data.installment_amount,
            esc_subsidy: data.esc_subsidy
          }
          this.$refs.LoadingDialog.dialog = false
        })
        .catch((data) => {
          this.$refs.LoadingDialog.dialog = false
        })
    },
    showTemplate () {
      this.$refs.LoadingDialog.dialog = true
      let queryString = `&payment_plan=${this.newEnrollment.payment_plan}&grade_level=${this.newEnrollment.grade_level}`
      if (this.newEnrollment.enrollment_type) {
        queryString += `&enrollment_type=${this.newEnrollment.enrollment_type}`
      }
      if (this.newEnrollment.track_type) {
        queryString += `&track_type=${this.newEnrollment.track_type}`
      }
      this.getTemplate(queryString)
        .then((data) => {
          this.newEnrollment.template = {
            tuition_fee: data.tuition_fee,
            registration_fee: data.registration_fee,
            miscellaneous_fee: data.miscellaneous_fee,
            computer_fee: data.computer_fee,
            total_books_fee: data.total_books_fee,
            num_installments: data.num_installments,
            installment_amount: data.installment_amount,
            esc_subsidy: data.esc_subsidy
          }
          this.$refs.LoadingDialog.dialog = false
        })
        .catch((data) => {
          this.$refs.LoadingDialog.dialog = false
        })
    },
    loadTemplate () {
      if (this.newEnrollment.grade_level <= 13) {
          this.newEnrollment.track_type = 1
      }
      if (! this.newEnrollment.payment_plan || ! this.newEnrollment.grade_level) {
        return
      }
      if (! this.newEnrollment.id) {
        this.applyTemplate()
      } else {
        this.showTemplate()
      }
    },
    forceApplyTemplate () {
      if (confirm('Are you sure you want apply this template?')) {
        if (this.newEnrollment.payment_plan && this.newEnrollment.grade_level) {
          this.applyTemplate()
        }
      }
    },
    addEnrollment() {
      let data = Object.assign(this.newEnrollment)
      data.student = this.student.id
      data.school_year = this.schoolYear.id
      this.createEnrollment(data)
        .then((data) => {
          this.$toastr('success', 'Enrollment added', '');
          this.successCallback();
          this.dialog = false
        })
        .catch((errors) => {
          this.$toastr('error', errors, 'error');
        })
    },
    editEnrollment() {
      const data = Object.assign(this.newEnrollment)
      this.updateEnrollment(data)
        .then(() => {
          this.$toastr('success', 'Enrollment updated!', '')
          this.successCallback();
          this.dialog = false
        })
        .catch(() => {
          this.$toastr('error', 'Error', 'Error')
        })
    },
    submitEnrollmentForm() {
      if (this.$refs.form.validate()) {
        this.newEnrollment.id ? this.editEnrollment() : this.addEnrollment()
      }
    },
    cancel() {
      this.$router.push({
        name: 'student-detail',
        id: this.$route.params.id
      });
    }
  },
}
</script>
